export const sortProvidedServicesByStartsAt = (providedServices) => (
  providedServices.sort((a, b) => (Date.parse(b.starts_at) - Date.parse(a.starts_at)))
);

export default sortProvidedServicesByStartsAt;
